import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastComponent } from './component/shared/toast.component';
import { AppInfo, ReleaseNotes } from './model/tops.models';
import { AuthService } from './auth/auth.service';
import { ApiService } from './service/api.service';
import { ToastService } from './service/toast.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit, OnDestroy {
  private readonly api = inject(ApiService);
  private readonly auth = inject(AuthService);
  private readonly toast = inject(ToastService);
  private readonly subscriptions = new Subscription();

  releaseNotes: ReleaseNotes | null = null;
  appInfo: AppInfo | null = null;
  showReleaseNotes = false;
  showUserMenu = false;

  ngOnInit(): void {
    void this.auth.initialize();
    this.subscriptions.add(this.api.getReleaseNotes().subscribe({ next: (notes) => this.releaseNotes = notes, error: () => {} }));
    this.subscriptions.add(this.api.getAppInfo().subscribe({ next: (info) => this.appInfo = info, error: () => {} }));
    window.addEventListener('tops:show-whats-new', this.openReleaseNotes);
    window.addEventListener('tops:show-user-menu', this.openUserMenu);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    window.removeEventListener('tops:show-whats-new', this.openReleaseNotes);
    window.removeEventListener('tops:show-user-menu', this.openUserMenu);
  }

  get releaseNoteChanges(): string[] {
    return this.releaseNotes?.changes || [];
  }

  openFolder(folder: 'data' | 'logs'): void {
    this.api.openFolder(folder).subscribe({
      next: () => {},
      error: (error) => this.toast.error('Error', error?.message || `Failed to open ${folder} folder.`),
    });
  }

  private readonly openReleaseNotes = (): void => {
    this.showReleaseNotes = true;
  };

  private readonly openUserMenu = (): void => {
    this.showUserMenu = true;
  };
}
